import { apiSlice } from "../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    forgetPassword: builder.mutation({
      query: ({ username }) => ({
        url: '/forgotPassword/enterEmail',
        method: 'POST',
        body: { username }, 
      }),
    }),
    googleSignIn: builder.mutation({
      query: ({ token }) => ({
        url: '/auth/googleSignIn',
        method: 'POST',
        body: { token }, // Sending token in the body of the request
      }),
    }),
  }),
});

export const { useForgetPasswordMutation,useGoogleSignInMutation } = sqlApiSlice;
